"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("./button"));
var _input = _interopRequireDefault(require("./input"));
var _col = _interopRequireDefault(require("./col"));
var _sendEmailButton = _interopRequireDefault(require("./send-email-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Expects props of
// flags, filterSets and emailFields (see below)
// sender - string, for the "to" field of the email
// emailSubject - string, default email subject
// onSend - function, to be action at the time user clicks send (in addition to opening of email client) - can be undefined.
// dataRecords - the data to be used in the filtering and functions.

// *******************************************************************************
// flags (array of flag objects)
// *******************************************************************************
// Flags are used for filter criteria that are limited to one of two options
// (shown as radio buttons)
// Each flag requires:
// id - string, must be unique,
// description - string, this is the section heading),
// canClear - boolean, controls whether radios can both be unselected,
// trueLabel - string,
// falseLabel - string,
// enabled - function(filteredRecords) to check whether options should be displayed.  Don't show flag options where current filters in use result in a zero option.
// check - function(state, record) to check whether current record matches selected criteria

// *******************************************************************************
// filterSets (array of objects)
// *******************************************************************************
// Filter sets are used where there are multiple options one or more of which may be selected at the same time (shown as checkboxes)
// If filters are active then sets which are not part of the filtering are removed if there are no records in the set.

// Each set requires:
// id - string, must be unique,
// description - string, this is the section heading,
// options - function(state, filteredRecords) to check whether options should be displayed. Only show options for which there are at least some records.
// check - function(state, record) to check whether current record matches selected criteria

// *******************************************************************************
// emailFields (array of objects)
// *******************************************************************************

// This indicates which fields on the record contain the email(s)
// If there is more than one email field then the user can select which one(s) to
// include via check boxes
// Each email field requires
// id - string
// description - string, a label for check boxes
// default - boolean, whether selected by default
// emailAddresses - function(record) to return the array of email addresses

// initial filters for state
function getInitialFilters(props) {
  const initialFilters = {};
  props.flags.map(f => initialFilters[f.id] = null);
  props.filterSets.map(s => initialFilters[s.id] = []);
  props.emailFields.map(e => initialFilters[e.id] = e.default);
  return initialFilters;
}

// *******************************************************************************
// Main Component
// *******************************************************************************
var _ref = /*#__PURE__*/_react.default.createElement("h5", null, "Who to Include:");
var _ref2 = /*#__PURE__*/_react.default.createElement("h4", {
  className: "card-header"
}, "Filtered Emails (use to bcc)");
class GroupEmail extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getInitialFilters(this.props));
    // Filter records ignores the current filter, but filters on all the others.
    // This stops set options from being hidden when user might wish to add them to the filter
    // and filtered radio buttons from being hidden.
    _defineProperty(this, "_getFilteredRecords", (dataRecords, currentFilter) => {
      return dataRecords.filter(record => this.props.filterSets.every(set => set.id === currentFilter || set.check(this.state, record)) && this.props.flags.every(flag => flag.id === currentFilter || flag.check(this.state, record)));
    });
    _defineProperty(this, "_getEmails", dataRecords => {
      const emails = [];
      const emailsToInclude = this.props.emailFields.filter(e => this.state[e.id]).map(e => e.id);
      dataRecords.map(record => {
        if (this.props.filterSets.every(set => set.check(this.state, record)) && this.props.flags.every(flag => flag.check(this.state, record))) {
          this.props.emailFields.map(field => {
            if (!emailsToInclude.length || emailsToInclude.includes(field.id)) {
              field.emailAddresses(record).map(email => {
                if (!emails.includes(email)) emails.push(email);
              });
            }
          });
        }
      });
      return emails.sort();
    });
    _defineProperty(this, "_onToggleFilterSet", (type, selectedID, value) => {
      this.setState({
        [type]: value ? this.state[type].concat([selectedID]) : this.state[type].filter(i => i !== selectedID)
      });
    });
    _defineProperty(this, "_onToggleEmailField", (value, emailFieldID) => {
      this.setState({
        [emailFieldID]: value
      });
    });
    _defineProperty(this, "_onSetFlagFilter", (flagID, value) => {
      this.setState({
        [flagID]: value
      });
    });
    _defineProperty(this, "_getClearFlagFilterButton", flagID => {
      if (this.state[flagID] === null) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "pull-xs-right"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        size: "sm",
        onClick: () => this.setState({
          [flagID]: null
        })
      }, "Clear"));
    });
    _defineProperty(this, "_getClearSetFilterButton", setID => {
      if (!this.state[setID].length) return null;
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "pull-xs-right"
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        size: "sm",
        onClick: () => this.setState({
          [setID]: []
        })
      }, "Clear"));
    });
    _defineProperty(this, "_onClearAllFilters", () => {
      this.setState(getInitialFilters(this.props));
    });
  }
  // *******************************************************************************
  // Render
  // *******************************************************************************

  render() {
    const dataRecords = this.props.dataRecords;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 5
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "card-header"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this._onClearAllFilters
    }, "Reset All")), "Filter By"), this.props.filterSets.map((set, i) => this.state[set.id].length === 0 && set.options(this.state, this._getFilteredRecords(dataRecords, set.id)).length <= 1 ? null : /*#__PURE__*/_react.default.createElement("div", {
      key: set.id,
      className: "card-block",
      style: i ? {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      } : null
    }, /*#__PURE__*/_react.default.createElement("h5", null, this._getClearSetFilterButton(set.id), set.description, ":"), set.options(this.state, this._getFilteredRecords(dataRecords, set.id)).map(option => /*#__PURE__*/_react.default.createElement("div", {
      key: option.id
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      className: "card-text",
      type: "Checkbox",
      checked: this.state[set.id].indexOf(option.id) > -1,
      onChange: value => this._onToggleFilterSet(set.id, option.id, value),
      label: option.description
    }))))), this.props.flags.map(flag => this.state[flag.id] === null && !flag.enabled(this._getFilteredRecords(dataRecords, flag.id)) ? null : /*#__PURE__*/_react.default.createElement("div", {
      key: flag.id,
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement("h5", null, !flag.canClear ? null : this._getClearFlagFilterButton(flag.id), flag.description, ":"), /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: flag.id,
      checked: this.state[flag.id] === true,
      label: flag.trueLabel,
      onChange: () => this._onSetFlagFilter(flag.id, true)
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Radio",
      name: flag.id,
      checked: this.state[flag.id] === false,
      label: flag.falseLabel,
      onChange: () => this._onSetFlagFilter(flag.id, false)
    }))), this.props.emailFields.length < 2 ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, _ref, this.props.emailFields.map(field => /*#__PURE__*/_react.default.createElement("div", {
      key: field.id
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this.state[field.id],
      name: field.id,
      onChange: this._onToggleEmailField,
      label: field.description
    })))))), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 7
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref2, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, this._getEmails(dataRecords).map(email => /*#__PURE__*/_react.default.createElement("p", {
      key: email,
      style: {
        marginBottom: 0
      }
    }, email)))))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_sendEmailButton.default, {
      to: this.props.sender,
      bcc: this._getEmails(dataRecords).join(', '),
      subject: this.props.emailSubject,
      onClick: this.props.onSend,
      block: true
    }, "Write and Send Email")));
  }
}
// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = GroupEmail;